import { Directive, inject } from '@angular/core';
import { MatSelect } from '@angular/material/select';

/** Esta diretiva é um artifício para o MatSelect entender que sempre tem conteúdo e assim
 *    renderizar o MatSelectTrigger mesmo que esteja vazio
 *  ATENÇÃO: pode causar efeitos colaterais, não foi testado em todas as situações
 */

@Directive({
  selector: 'mat-select[slc-select]',
  standalone: true,
})
export class SliceSelectDirective {
  private matSelect = inject(MatSelect, { self: true });

  ngOnInit(): void {
    Object.defineProperty(this.matSelect, 'empty', {
      get: function () {
        return false;
      },
    });

    // Evita q teclas como KEY_DOWN ou outras abram a lista
    const anyMatSelect = this.matSelect as any;
    anyMatSelect._handleClosedKeydown = (event: KeyboardEvent): void => {};
  }
}
